<template>
  <div class="asd20-tag-group" :class="classes">
    <asd20-tag v-for="(tag, index) in tags" :key="index" :label="tag" />
    <slot />
  </div>
</template>

<script>
import Asd20Tag from '../../../components/atoms/Asd20Tag'

export default {
  name: 'Asd20TagGroup',

  components: {
    Asd20Tag,
  },

  model: {
    prop: 'tags',
  },

  props: {
    tags: { type: Array, default: () => [] },
  },

  computed: {
    classes() {
      return {}
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../../design/_mixins.scss';
@import '../../../design/_variables.scss';

.asd20-tag-group {
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: space(-0.125);
  .asd20-tag {
    margin-right: space(0.125);
    margin-bottom: space(0.125);
  }
}
</style>
